(() => {
  'use strict';
  const shopify = window.Shopify;
  const query = new URLSearchParams(window.location.search);
  if (window.__dndMeasurementV3 || shopify?.designMode || shopify?.previewMode) return;
  if (query.has('preview_theme_id') || /(^|\.)shopifypreview\.com$/.test(window.location.hostname)) return;
  if (shopify?.theme?.role && shopify.theme.role !== 'main') return;
  if (/^\/(account|customers|checkouts|challenge)(\/|$)/.test(window.location.pathname)) return;
  window.__dndMeasurementV3 = true;

  const script = document.currentScript;
  const pageType = script?.dataset.pageType || 'unknown';
  const ga4Id = script?.dataset.ga4Id || '';
  const path = window.location.pathname.replace(/\/$/, '') || '/';
  const referrer = (() => {
    try {
      const url = new URL(document.referrer);
      return ['https:', 'http:'].includes(url.protocol) ? url.origin + '/' : '';
    } catch (_) { return ''; }
  })();
  const storageKey = 'dnd_enquiry_v3';
  const maxAge = 86400000;
  const queue = [];
  let providerReady = false;
  let providerFunction;
  let probeAt = -Infinity;
  let timer;
  let deadline = 0;
  let candidate;
  let checkedCandidate = false;
  let submittedHere = false;

  const allowed = (method) => {
    try { return window.Shopify?.customerPrivacy?.[method]?.() === true; }
    catch (_) { return false; }
  };
  const clearStored = () => {
    try {
      window.sessionStorage.removeItem(storageKey);
      window.sessionStorage.removeItem('dnd_quote_pending_v2');
    } catch (_) {}
  };
  const store = (record) => {
    try {
      window.sessionStorage.setItem(storageKey, JSON.stringify(record));
      return true;
    } catch (_) { return false; }
  };
  const discard = () => {
    clearStored();
    candidate = null;
    queue.length = 0;
    providerReady = false;
  };
  const placement = (element) => {
    if (element.closest('#header-group, .shopify-section-group-header-group, header-component')) return 'navigation';
    if (element.closest('footer, .dnd-footer-main, .shopify-section-group-footer-group')) return 'footer';
    if (element.closest('[data-dnd-growth-links]')) return 'article_followup';
    const hero = element.closest('.dnd-home__actions, .dnd-pagehero');
    if (path === '/') return hero ? 'homepage_hero' : 'homepage_content';
    if (path === '/pages/fox-gps-professional-pest-control-australia') return hero ? 'fox_gps_hero' : 'fox_gps_content';
    if (path === '/pages/professional-pest-control-wa') return hero ? 'pest_control_hero' : 'pest_control_content';
    if (path === '/pages/request-pest-control-quote') return 'quote_page';
    if (element.closest('dnd-contact-flow')) return 'contact_page';
    return 'page';
  };
  const classify = (anchor) => {
    let target;
    try { target = new URL(anchor.href, window.location.href); } catch (_) { return null; }
    if (target.protocol === 'tel:') return 'phone_contact_click';
    if (target.protocol === 'mailto:') return 'email_contact_click';
    if (!['https:', 'http:'].includes(target.protocol)) return null;
    const targetPath = target.pathname.replace(/\/$/, '') || '/';
    if (target.hostname === 'foxgps.dieselndusthunting.com.au') {
      if (targetPath === '/plans') return 'fox_gps_plans_click';
      if (targetPath === '/guide') return 'fox_gps_guide_click';
      if (targetPath === '/demo') return 'fox_gps_demo_click';
      if (targetPath === '/signin-with-chatgpt') return 'fox_gps_signin_click';
      return 'fox_gps_open_click';
    }
    if (target.origin !== window.location.origin) return null;
    if (targetPath === '/pages/request-pest-control-quote') return 'pest_control_quote_click';
    if (targetPath === '/pages/professional-pest-control-wa') return 'pest_control_services_click';
    if (targetPath === '/pages/fox-gps-professional-pest-control-australia') return 'fox_gps_information_click';
    if (targetPath.startsWith('/products/')) return 'product_click';
    if (targetPath.startsWith('/collections/')) return 'shop_browse_click';
    return null;
  };
  const formType = (form) => {
    if (form.id === 'PestControlQuoteForm') return 'pest_control_quote';
    if (form.matches('dnd-contact-flow form[data-contact-form]')) return 'contact_enquiry';
    return null;
  };
  const confirm = () => {
    if (submittedHere || checkedCandidate || !allowed('analyticsProcessingAllowed')) return;
    checkedCandidate = true;
    let stored;
    try { stored = JSON.parse(window.sessionStorage.getItem(storageKey) || 'null'); } catch (_) { return; }
    if (!stored) return;
    if (!Number.isFinite(stored.at) || Date.now() - stored.at < 0 || Date.now() - stored.at > maxAge) {
      clearStored();
      return;
    }
    if (stored.path !== path || stored.state !== 'pending' || !/^[a-f0-9]{32}$/.test(stored.id)) return;
    const forms = Array.from(document.querySelectorAll('#PestControlQuoteForm, dnd-contact-flow form[data-contact-form]'));
    const form = forms.find((item) => item.id === stored.formId && formType(item) === stored.type);
    if (!form) return;
    const isQuote = stored.type === 'pest_control_quote';
    if (form.querySelector(isQuote ? '[data-dnd-quote-error]' : '[data-server-error]')) {
      clearStored();
      return;
    }
    if (!form.querySelector(isQuote ? '[data-dnd-quote-confirmed]' : '[data-server-success]')) return;
    candidate = stored;
    queue.unshift({ name: 'generate_lead', details: { lead_type: stored.type, placement: stored.type === 'pest_control_quote' ? 'quote_form' : 'contact_form' }, at: Date.now(), enquiry: stored });
  };
  const forwardMeta = (name, payload) => {
    if (!allowed('analyticsProcessingAllowed') || !allowed('marketingAllowed') || !allowed('saleOfDataAllowed')) return;
    if (typeof window.fbq !== 'function') return;
    try { window.fbq('trackCustom', 'DNDInteraction', { action: name, page_type: payload.page_type, ...payload.details }); } catch (_) {}
  };
  const dispatch = (item) => {
    if (!allowed('analyticsProcessingAllowed')) return;
    if (item.enquiry) {
      if (item.enquiry !== candidate || submittedHere) return;
      item.enquiry.state = 'dispatched';
      if (!store(item.enquiry)) return;
    }
    const payload = {
      page_type: pageType,
      ...item.details,
      page_location: window.location.origin + path,
      page_referrer: referrer,
      send_to: ga4Id,
      event_callback: () => {
        if (item.processed) return;
        item.processed = true;
        if (item.enquiry && allowed('analyticsProcessingAllowed')) {
          let current;
          try { current = JSON.parse(window.sessionStorage.getItem(storageKey) || 'null'); } catch (_) {}
          if (current?.id === item.enquiry.id && current.state === 'dispatched') store({ ...current, state: 'processed' });
        }
        forwardMeta(item.name, { page_type: pageType, details: item.details });
      }
    };
    try { window.gtag('event', item.name, payload); } catch (_) {}
  };
  const flush = () => {
    if (!allowed('analyticsProcessingAllowed')) return;
    confirm();
    if (!queue.length || !/^G-[A-Z0-9]+$/.test(ga4Id) || typeof window.gtag !== 'function') return;
    if (providerFunction !== window.gtag) {
      providerFunction = window.gtag;
      providerReady = false;
      probeAt = -Infinity;
    }
    if (!providerReady) {
      if (Date.now() - probeAt < 5000) return;
      probeAt = Date.now();
      const probingFunction = providerFunction;
      try {
        probingFunction('get', ga4Id, 'client_id', (value) => {
          if (!value || probingFunction !== window.gtag || !allowed('analyticsProcessingAllowed')) return;
          providerReady = true;
          flush();
        });
      } catch (_) {}
      return;
    }
    while (queue.length && allowed('analyticsProcessingAllowed')) {
      const item = queue.shift();
      if (Date.now() - item.at > (item.enquiry ? maxAge : 30000)) continue;
      dispatch(item);
    }
  };
  const tick = () => {
    timer = undefined;
    flush();
    if (Date.now() < deadline && (queue.length || !checkedCandidate)) timer = window.setTimeout(tick, 1000);
  };
  const wake = () => {
    deadline = Date.now() + 120000;
    flush();
    if (!timer && (queue.length || !checkedCandidate)) timer = window.setTimeout(tick, 1000);
  };
  const emit = (name, details = {}) => {
    if (!allowed('analyticsProcessingAllowed')) return;
    if (queue.length >= 20) return;
    queue.push({ name, details, at: Date.now() });
    wake();
  };
  document.addEventListener('click', (event) => {
    const anchor = event.target?.closest?.('a[href]');
    if (!anchor) return;
    const name = classify(anchor);
    if (name) emit(name, { placement: placement(anchor) });
  }, { passive: true });
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.checkValidity()) return;
    const type = formType(form);
    if (type) {
      submittedHere = true;
      candidate = null;
      if (!allowed('analyticsProcessingAllowed')) { discard(); return; }
      let id;
      try { id = Array.from(window.crypto.getRandomValues(new Uint8Array(16)), (byte) => byte.toString(16).padStart(2, '0')).join(''); } catch (_) { return; }
      store({ id, at: Date.now(), path, formId: form.id, type, state: 'pending' });
      emit(type === 'pest_control_quote' ? 'pest_control_quote_submit_attempt' : 'contact_enquiry_submit_attempt', { placement: type === 'pest_control_quote' ? 'quote_form' : 'contact_form' });
    } else if (/\/cart\/add(?:[/?]|$)/.test(form.action)) emit('add_to_cart_submit');
  });
  document.addEventListener('visitorConsentCollected', () => {
    if (!allowed('analyticsProcessingAllowed')) discard();
    else wake();
  });
  window.addEventListener('pageshow', wake);
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') wake();
  });
  if (!shopify?.customerPrivacy && typeof shopify?.loadFeatures === 'function') {
    shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
      if (!error) {
        if (!allowed('analyticsProcessingAllowed')) discard();
        else wake();
      }
    });
  }
  if (shopify?.customerPrivacy && !allowed('analyticsProcessingAllowed')) discard();
  wake();
})();
